import { Box, styled } from '@mui/material';

export const Container = styled(Box)({
  width: '100%',
  background: '#E5E5E5',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
});
